// extracted by mini-css-extract-plugin
export default {"overlay":"messageModal_overlay__xZdlm","modalContet":"messageModal_modalContet__ISMXX","buttonBox":"messageModal_buttonBox__01VF2"};